import Vue from "vue"
import App from "./App"
import router from "./router/"
import { i18n } from "@/locales/setup.js"
import VueScrollTo from "vue-scrollto"
import canDirective from "./permissions/directive.js"
import VModal from "vue-js-modal"
import VTooltip from "v-tooltip"
import store from "./store/"
import responseInterceptor from "@/api/responseInterceptor.js"

// ScrollTo
Vue.use(VueScrollTo)

// Modal
Vue.use(VModal, { componentName: "v-modal" })

// Tooltip directive
// https://github.com/Akryum/v-tooltip
Vue.use(VTooltip)

// Register can directive for permissions
Vue.directive("can", canDirective)

// Axios interceptor to handle network and auth errors globally
responseInterceptor()

Vue.config.productionTip = false

/**
 * Adding some polyfills for IE11
 */

// startsWith
if (!String.prototype.startsWith) {
	Object.defineProperty(String.prototype, "startsWith", {
		value: function(search, pos) {
			pos = !pos || pos < 0 ? 0 : +pos
			return this.substring(pos, pos + search.length) === search
		}
	})
}

const app = new Vue({
	el: "#app",
	router,
	i18n,
	store,
	components: { App },
	template: "<App/>"
})

export default app
